(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bars = document.querySelectorAll('[data-announcement-bar]');
    bars.forEach((bar) => {
      const setHeightVar = () => {
        const visible = !bar.classList.contains('is-dismissed') && !bar.classList.contains('is-collapsed');
        const h = visible ? bar.offsetHeight : 0;
        document.documentElement.style.setProperty('--site-ab-height', h + 'px');
      };
      const dismissBtn = bar.querySelector('[data-ab-dismiss]');
      if (dismissBtn) {
        dismissBtn.addEventListener('click', () => {
          bar.classList.add('is-dismissed');
          setHeightVar();
          window.dispatchEvent(new CustomEvent('announcement:dismissed'));
        });
      }
      setHeightVar();
      window.addEventListener('resize', setHeightVar);

      const updateCollapse = () => {
        const collapsed = window.scrollY > 0;
        if (bar.classList.contains('is-collapsed') === collapsed) return;
        bar.classList.toggle('is-collapsed', collapsed);
        setHeightVar();
      };
      updateCollapse();
      window.addEventListener('scroll', updateCollapse, { passive: true });

      const track = bar.querySelector('[data-ab-track]');
      const viewport = bar.querySelector('.site-announcement__viewport');
      if (track && viewport) {
        const ensureFill = () => {
          const baseGroups = Array.from(track.children).slice(0, 2);
          if (baseGroups.length < 2) return;
          while (track.children.length < 32 && track.scrollWidth < viewport.offsetWidth * 2) {
            baseGroups.forEach((g) => {
              const clone = g.cloneNode(true);
              clone.setAttribute('aria-hidden', 'true');
              track.appendChild(clone);
            });
          }
        };
        ensureFill();
        window.addEventListener('resize', ensureFill);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.brand-bar').forEach((root) => {
      const scroll = root.querySelector('[data-bb-scroll]');
      const bar    = root.querySelector('[data-bb-scrollbar]');
      const thumb  = root.querySelector('[data-bb-thumb]');
      if (!scroll || !bar || !thumb) return;

      const update = () => {
        const visible = scroll.clientWidth;
        const total   = scroll.scrollWidth;
        // No overflow → hide the indicator.
        if (total <= visible + 1) {
          bar.setAttribute('hidden', '');
          return;
        }
        bar.removeAttribute('hidden');
        const trackW  = bar.clientWidth;
        const ratio   = visible / total;
        // Minimum thumb width so it's never an invisible sliver on long rows.
        const thumbW  = Math.max(24, trackW * ratio);
        const maxScr  = total - visible;
        const tx      = maxScr > 0 ? (scroll.scrollLeft / maxScr) * (trackW - thumbW) : 0;
        thumb.style.setProperty('--bb-thumb-w', thumbW + 'px');
        thumb.style.setProperty('--bb-thumb-x', tx + 'px');
      };

      scroll.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      // Recompute when tile sizes change (image loads, font swap, etc.).
      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(update);
        ro.observe(scroll);
      }

      // Initial paint — wait one frame so the layout has settled.
      requestAnimationFrame(update);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-icons-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-category-icons]').forEach((root) => {
      const tabs = root.querySelectorAll('[data-tab]');
      const panels = root.querySelectorAll('[data-panel]');
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const key = tab.dataset.tab;
          tabs.forEach((t) => {
            const active = t.dataset.tab === key;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach((p) => {
            const active = p.dataset.panel === key;
            p.classList.toggle('is-active', active);
            if (active) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-cart-sticky"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-collection-cart-sticky]');
    if (!root) return;
    const stack    = root.querySelector('[data-ccs-stack]');
    const countEl  = root.querySelector('[data-ccs-count]');
    const amountEl = root.querySelector('[data-ccs-amount]');
    const shipEl   = root.querySelector('[data-ccs-ship]');
    const threshold = parseInt(root.dataset.threshold, 10) || 0;

    // On PDP, only reveal once the main-product section has scrolled out of view.
    // On any other template, the gate stays unlocked from the start.
    const mainProduct = document.querySelector('[data-main-product]');
    let scrollGateOpen = !mainProduct;
    let lastCart = null;

    if (mainProduct && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          // "Past" = the bottom of main-product is above the viewport top.
          const rect = e.boundingClientRect;
          scrollGateOpen = !e.isIntersecting && rect.bottom <= 0;
          if (lastCart) render(lastCart);
        });
      }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
      io.observe(mainProduct);
      // Also re-evaluate on scroll for the case where IntersectionObserver
      // fires once and then the user scrolls back up.
      window.addEventListener('scroll', () => {
        const rect = mainProduct.getBoundingClientRect();
        const next = rect.bottom <= 0;
        if (next !== scrollGateOpen) {
          scrollGateOpen = next;
          if (lastCart) render(lastCart);
        }
      }, { passive: true });
    }

    // Maps Shopify's cart.currency ISO code to a symbol so the sticky
    // bar shows "534,45 €" instead of the literal "534,45 EUR". Falls
    // back to the ISO code itself for currencies we haven't enumerated.
    const CURRENCY_SYMBOLS = {
      EUR: '€', USD: '$', GBP: '£', JPY: '¥', CHF: 'CHF',
      CAD: '$', AUD: '$', NZD: '$', SEK: 'kr', NOK: 'kr',
      DKK: 'kr', PLN: 'zł', CZK: 'Kč', HUF: 'Ft', RON: 'lei',
      BGN: 'лв', BRL: 'R$', MXN: '$', ARS: '$', CLP: '$',
      KRW: '₩', CNY: '¥', INR: '₹', TRY: '₺', RUB: '₽',
      ZAR: 'R'
    };
    function formatMoney(cents, iso) {
      const amount = (cents / 100).toFixed(2).replace('.', ',');
      const symbol = CURRENCY_SYMBOLS[iso] || iso || '€';
      return `${amount} ${symbol}`;
    }

    function render(cart) {
      lastCart = cart;
      if (!cart || cart.item_count === 0 || !scrollGateOpen) {
        root.hidden = true;
        return;
      }
      // image stack (up to 3 unique items)
      stack.innerHTML = '';
      const seen = new Set();
      for (const item of cart.items) {
        if (seen.has(item.product_id)) continue;
        seen.add(item.product_id);
        if (item.image) {
          const img = document.createElement('img');
          img.src = item.image.replace(/(\.(jpg|jpeg|png|webp))/i, '_x100$1');
          img.alt = item.product_title || '';
          stack.appendChild(img);
        }
        if (seen.size >= 3) break;
      }
      const iso = (cart.currency || 'EUR').toUpperCase();
      // Localised strings. NOTE: Liquid is NOT processed inside {% javascript %}
      // blocks (Shopify bundles them verbatim into compiled_assets/scripts.js),
      // so {{ ... | t }} here would ship raw and break the WHOLE bundle. Read
      // the translated strings from data-attributes on the root instead.
      const T_PRODUCT_ONE   = root.dataset.tProductOne   || '%COUNT%';
      const T_PRODUCT_OTHER = root.dataset.tProductOther || '%COUNT%';
      const T_TOTAL         = root.dataset.tTotal        || 'Total';
      const T_FREE_REACHED  = root.dataset.tFreeReached  || '';
      const T_FREE_REMAIN   = root.dataset.tFreeRemain   || '';
      const productsText = (cart.item_count === 1 ? T_PRODUCT_ONE : T_PRODUCT_OTHER)
        .replace('%COUNT%', cart.item_count);
      countEl.textContent = productsText;
      amountEl.textContent = `${T_TOTAL}: ${formatMoney(cart.total_price, iso)}`;
      if (threshold > 0) {
        const delta = threshold - cart.total_price;
        if (delta <= 0) {
          shipEl.textContent = T_FREE_REACHED;
          shipEl.classList.add('ccs__ship--unlocked');
        } else {
          shipEl.textContent = T_FREE_REMAIN.replace('%AMOUNT%', formatMoney(delta, iso));
          shipEl.classList.remove('ccs__ship--unlocked');
        }
      } else {
        shipEl.textContent = '';
      }
      root.hidden = false;
    }

    async function syncFromCart() {
      try {
        const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        if (!r.ok) return;
        render(await r.json());
      } catch { /* swallow */ }
    }

    syncFromCart();
    document.addEventListener('cart:item-added', syncFromCart);
    document.addEventListener('cart:updated', syncFromCart);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-email-popup]').forEach((root) => {
      const KEY = root.dataset.popupKey || 'clab:email-popup:dismissed';
      const SUPPRESS_DAYS = 30;
      const now = Date.now();
      try {
        const last = parseInt(localStorage.getItem(KEY) || '0', 10);
        if (last && now - last < SUPPRESS_DAYS * 86400 * 1000) return;
      } catch (_) {}
      const delay = parseInt(root.dataset.popupDelay, 10) || 8000;
      const open = () => { root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
      const close = () => {
        root.classList.remove('is-open');
        root.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        try { localStorage.setItem(KEY, String(Date.now())); } catch (_) {}
      };
      setTimeout(open, delay);
      root.querySelectorAll('[data-popup-close]').forEach((el) => el.addEventListener('click', close));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });
      // If the form posted successfully, persist the dismissal so the
      // popup doesn't return for SUPPRESS_DAYS even after the user
      // refreshes the success view.
      if (root.querySelector('[data-popup-success]')) {
        try { localStorage.setItem(KEY, String(Date.now())); } catch (_) {}
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;

    const mode = header.dataset.stickyMode;           // off | always | scroll_up
    const transparentInit = header.dataset.transparentInit === 'true';
    const stickyThreshold = parseInt(header.dataset.stickyThreshold, 10) || 60;

    // Sticky-scrolled state: toggles bg/fg/height/logo when scrolled past threshold.
    // Independent of transparent mode — they can both be active (e.g. transparent
    // hero AND scrolled-down sticky bar).
    const updateStickyScrolled = () => {
      const past = window.scrollY > stickyThreshold;
      header.classList.toggle('is-sticky-scrolled', past);
    };

    // Body padding compensation — driven by SCROLL POSITION + page's transparent
    // intent, NOT by the live .is-transparent class (which can be force-toggled
    // by hover/search without changing the hero/page layout). If we used the
    // class, hover would shift the hero image down by the header's height, which
    // the user perceived as a 'jump'.
    const updatePad = () => {
      if (!header.classList.contains('is-fixed')) {
        document.body.style.paddingTop = '';
        document.documentElement.style.setProperty('--site-header-offset', '0px');
        document.documentElement.style.setProperty('--site-header-h', '0px');
        return;
      }
      // AB is fixed at top (z-index above header). Header is fixed below it
      // at top: var(--site-ab-height). Body padding reserves space for BOTH.
      const abHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--site-ab-height')) || 0;
      document.documentElement.style.setProperty('--site-header-h', header.offsetHeight + 'px');
      const transparentArea = transparentInit && window.scrollY <= 40;
      if (transparentArea) {
        document.body.style.paddingTop = '';
      } else {
        document.body.style.paddingTop = (header.offsetHeight + abHeight) + 'px';
      }
      // Offset = the header's LIVE bottom edge, so fixed panels (megamenu,
      // PDP sticky bars) dock exactly under it in ANY state. Using
      // offsetHeight + abHeight broke once sticky-scrolled (header moves to
      // top:0, AB no longer above it) → left a gap the size of the AB.
      const hiddenNow = header.classList.contains('is-hidden');
      const liveBottom = hiddenNow ? 0 : Math.max(0, header.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty('--site-header-offset', liveBottom + 'px');
    };

    const setSolid = () => {
      if (!header.classList.contains('is-transparent')) return;
      header.classList.remove('is-transparent');
      updatePad();
    };
    const setTransparent = () => {
      if (!transparentInit) return;
      if (header.classList.contains('is-transparent')) return;
      header.classList.add('is-transparent');
      updatePad();
    };

    if (mode === 'off') {
      return;
    }

    updatePad();
    window.addEventListener('resize', updatePad);
    window.addEventListener('announcement:dismissed', updatePad);

    let lastY = window.scrollY;
    const threshold = 8;
    // Forced-solid flags: when any of these is on, transparency is suppressed
    // until all are off and the scroll state re-allows it. Desktop only — we
    // don't flicker the mobile header on every icon tap.
    let hoverForce = false;
    let searchForce = false;
    const desktopMQ = window.matchMedia('(min-width: 1024px)');

    const applyTransparency = () => {
      const y = window.scrollY;
      const forced = (hoverForce || searchForce) && desktopMQ.matches;
      if (y > 40 || forced) setSolid(); else setTransparent();
    };

    const tpl = header.dataset.template || '';
    const onScroll = () => {
      const y = window.scrollY;
      applyTransparency();
      updateStickyScrolled();

      const wasHidden = header.classList.contains('is-hidden');
      if (mode === 'scroll_up') {
        const delta = y - lastY;
        if (y > 120 && delta > threshold) header.classList.add('is-hidden');
        else if (delta < -threshold) header.classList.remove('is-hidden');
      }

      // PDC/PDP exception — collapse only the nav row on scroll down, show on scroll up.
      if (tpl === 'collection' || tpl === 'product') {
        const delta = y - lastY;
        if (y > 80 && delta > threshold) header.classList.add('is-nav-collapsed');
        else if (delta < -threshold) header.classList.remove('is-nav-collapsed');
      }
      const isHidden = header.classList.contains('is-hidden');
      // Recompute on EVERY scroll: the header shrinks on .is-sticky-scrolled and
      // shifts from top:var(--site-ab-height) to top:0, so the offset must track
      // its live bottom edge (was only updated on hidden-toggle → megamenu gap).
      const liveBottom2 = isHidden ? 0 : Math.max(0, header.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty('--site-header-offset', liveBottom2 + 'px');
      // Keep --site-header-h in sync as the header height shrinks/grows with
      // the sticky-scrolled transition, so the announcement bar (which sits
      // pinned at top: var(--site-header-h)) tracks the change.
      document.documentElement.style.setProperty('--site-header-h', (isHidden ? 0 : header.offsetHeight) + 'px');
      lastY = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    // Desktop-only: hover on the header forces solid; leave reverts.
    header.addEventListener('mouseenter', () => {
      if (!desktopMQ.matches) return;
      hoverForce = true;
      applyTransparency();
    });
    header.addEventListener('mouseleave', () => {
      hoverForce = false;
      applyTransparency();
    });

    // Search modal open/close forces solid too (modal has white body; transparent
    // header over a modal backdrop looks broken).
    document.addEventListener('click', (e) => {
      const trigger = e.target && e.target.closest && e.target.closest('[data-search-modal-open]');
      if (trigger) { searchForce = true; applyTransparency(); }
      const closer = e.target && e.target.closest && e.target.closest('[data-search-modal-close]');
      if (closer) { searchForce = false; applyTransparency(); }
    }, true);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchForce) { searchForce = false; applyTransparency(); }
    });
    desktopMQ.addEventListener && desktopMQ.addEventListener('change', applyTransparency);

    onScroll();
  })();

  /* ===== Mobile nav drawer ===== */
  (function () {
    const drawer = document.querySelector('[data-nav-drawer]');
    if (!drawer) return;
    const root = document.documentElement;
    const esc = (s) => (window.CSS && CSS.escape) ? CSS.escape(s) : String(s).replace(/"/g, '\\"');
    const allSubs = () => document.querySelectorAll('[data-drawer-sub]');
    let stack = [];

    const closeSubs = () => { allSubs().forEach(s => s.setAttribute('aria-hidden', 'true')); stack = []; };
    const openDrawer = () => { drawer.setAttribute('aria-hidden', 'false'); root.classList.add('nav-drawer-open'); };
    const closeDrawer = () => {
      drawer.setAttribute('aria-hidden', 'true');
      root.classList.remove('nav-drawer-open');
      setTimeout(closeSubs, 320);
    };
    const openSub = (key) => {
      const sub = document.querySelector('[data-drawer-sub="' + esc(key) + '"]');
      if (!sub) return;
      sub.setAttribute('aria-hidden', 'false');
      stack.push(sub);
    };
    const back = () => { const cur = stack.pop(); if (cur) cur.setAttribute('aria-hidden', 'true'); };

    document.addEventListener('click', (e) => {
      const t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-nav-drawer-open]')) { e.preventDefault(); openDrawer(); return; }
      if (t.closest('[data-nav-drawer-close]')) { e.preventDefault(); closeDrawer(); return; }
      const to = t.closest('[data-drawer-to]');
      if (to) { e.preventDefault(); openSub(to.getAttribute('data-drawer-to')); return; }
      if (t.closest('[data-drawer-back]')) { e.preventDefault(); back(); return; }
      // Cart trigger inside the drawer: let the cart drawer open, but close the nav drawer.
      if (drawer.getAttribute('aria-hidden') === 'false' && t.closest('[data-cart-drawer-open]') && drawer.contains(t.closest('[data-cart-drawer-open]'))) {
        closeDrawer();
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
        if (stack.length) back(); else closeDrawer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  /* Same autoplay helper used by shop-the-look videos: the bare `autoplay`
     attribute is unreliable on mobile and under various browser energy /
     data-saver policies. Call .play() explicitly, retry muted if the
     promise rejects, and (re-)trigger on section reload / pageshow so it
     plays inside the theme editor too. */
  (function () {
    function initVideos(root) {
      const videos = (root || document).querySelectorAll('.hero-banner__video');
      if (!videos.length) return;
      const tryPlay = (v) => {
        const p = v.play();
        if (p && typeof p.catch === 'function') {
          p.catch(() => {
            v.muted = true;
            v.play().catch(() => {});
          });
        }
      };
      videos.forEach((v) => {
        v.muted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.playsInline = true;
        if (v.readyState >= 2) tryPlay(v);
        else v.addEventListener('loadeddata', () => tryPlay(v), { once: true });
      });
    }
    document.addEventListener('DOMContentLoaded', () => initVideos(document));
    document.addEventListener('shopify:section:load', (e) => initVideos(e.target));
    document.addEventListener('visibilitychange', () => { if (!document.hidden) initVideos(document); });
    window.addEventListener('pageshow', () => initVideos(document));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ig-feed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initVideos(root) {
      const videos = (root || document).querySelectorAll('.shop-the-look__video');
      if (!videos.length) return;
      const tryPlay = (v) => {
        const p = v.play();
        if (p && typeof p.catch === 'function') {
          p.catch(() => {
            v.muted = true;
            v.play().catch(() => {});
          });
        }
      };
      videos.forEach((v) => {
        v.muted = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.playsInline = true;
        if (v.readyState >= 2) tryPlay(v);
        else v.addEventListener('loadeddata', () => tryPlay(v), { once: true });
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) tryPlay(v);
              else if (!v.paused) v.pause();
            });
          }, { threshold: 0.1 });
          io.observe(v);
        }
      });
    }
    document.addEventListener('DOMContentLoaded', () => initVideos(document));
    document.addEventListener('shopify:section:load', (e) => initVideos(e.target));
    document.addEventListener('visibilitychange', () => { if (!document.hidden) initVideos(document); });
    window.addEventListener('pageshow', () => initVideos(document));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.main-collection').forEach((root) => {
      const form = root.querySelector('form[id^="filter-form"]');
      const sortInput = root.querySelector('[data-mc-sort-input]');

      // Auto-submit on filter change — but ONLY when change came from chips bar (desktop UI).
      // Modal changes are buffered and submitted on "Ver resultados" click.
      form?.addEventListener('change', (e) => {
        if (e.target.matches('[data-mc-sort-radio]')) {
          if (sortInput) sortInput.value = e.target.value;
        }
        if (e.target.closest('[data-mc-modal]')) return; // modal — don't auto-submit
        form.submit();
      });

      // Close other filter panels when one opens
      const detailsList = root.querySelectorAll('.main-collection__filter-details');
      detailsList.forEach((d) => {
        d.addEventListener('toggle', () => {
          if (d.open) detailsList.forEach((other) => { if (other !== d) other.open = false; });
        });
      });

      // Gender accordion — toggle tipo_prenda children without leaving page
      root.querySelectorAll('[data-mc-genero-toggle]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const expanded = btn.getAttribute('aria-expanded') === 'true';
          const panelId  = btn.getAttribute('aria-controls');
          const panel    = panelId ? root.querySelector('#' + panelId) : null;
          btn.setAttribute('aria-expanded', String(!expanded));
          if (panel) panel.hidden = expanded;
          btn.closest('.main-collection__sidebar-item')?.classList.toggle('is-open', !expanded);
        });
      });

      // ===== Mobile filter modal =====
      const modal = root.querySelector('[data-mc-modal]');
      if (modal) {
        const pages = modal.querySelectorAll('[data-mc-page]');
        const pageMap = {};
        pages.forEach(p => { pageMap[p.dataset.mcPage] = p; });
        const rootPage = pageMap['root'];

        const openModal = () => { modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
        const closeModal = () => { modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; goToPage('root'); };
        const goToPage = (key) => {
          pages.forEach(p => { p.classList.remove('is-active'); p.hidden = (p.dataset.mcPage !== key); });
          const target = pageMap[key];
          if (target) { target.classList.add('is-active'); target.hidden = false; }
        };

        modal.addEventListener('click', (e) => {
          if (e.target.closest('[data-mc-modal-close]')) { e.preventDefault(); closeModal(); return; }
          const open = e.target.closest('[data-mc-open-page]');
          if (open) { e.preventDefault(); goToPage(open.dataset.mcOpenPage); return; }
          const back = e.target.closest('[data-mc-back]');
          if (back) { e.preventDefault(); goToPage('root'); return; }
        });

        document.addEventListener('click', (e) => {
          if (e.target.closest('[data-mc-modal-open]')) { e.preventDefault(); openModal(); }
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal();
        });

        // Update the row-value text + apply-button count whenever a modal input changes
        const rowValues = root.querySelectorAll('[data-mc-row-value]');
        const applyBtn = modal.querySelector('.main-collection__modal-apply');
        const applyBaseLabel = applyBtn ? applyBtn.textContent.replace(/\s*\(\d+\)\s*$/, '').trim() : 'Ver resultados';
        const updateRowValues = () => {
          rowValues.forEach(rv => {
            const key = rv.dataset.mcRowValue;
            const page = pageMap[key];
            if (!page) return;
            if (key === 'sort') {
              const chosen = page.querySelector('input[type="radio"]:checked');
              const label = chosen?.dataset.modalLabel || chosen?.nextElementSibling?.textContent.trim() || '';
              if (label) { rv.textContent = label; rv.classList.add('is-active'); }
            } else {
              const chosen = page.querySelectorAll('input[type="checkbox"]:checked');
              if (chosen.length === 0) {
                rv.textContent = 'Todos';
                rv.classList.remove('is-active');
              } else {
                const labels = Array.from(chosen).map(c => c.dataset.modalLabel || c.value);
                rv.textContent = labels.join(', ');
                rv.classList.add('is-active');
              }
            }
          });
        };
        modal.addEventListener('change', updateRowValues);

        // ===== Viewport-based input toggle =====
        // On mobile, chips bar inputs are visually hidden but still in form → disable them
        // so only modal inputs submit. On desktop, modal inputs are hidden → disable them.
        const chipsInputs = root.querySelectorAll('.main-collection__filters input, .main-collection__bar-bottom input');
        const modalInputs = modal.querySelectorAll('input');
        const syncInputsByViewport = () => {
          const isMobile = window.matchMedia('(max-width: 767px)').matches;
          chipsInputs.forEach(inp => { inp.disabled = isMobile && !inp.dataset.alwaysEnabled; });
          modalInputs.forEach(inp => { inp.disabled = !isMobile; });
        };
        // Skip disabling the hidden sort_by input that backs the chips path on submit:
        if (sortInput) sortInput.dataset.alwaysEnabled = 'true';
        syncInputsByViewport();
        window.addEventListener('resize', syncInputsByViewport);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-main-product]').forEach((root) => {
      const thumbs = root.querySelectorAll('[data-mp-thumb]');
      const slides = root.querySelectorAll('[data-mp-slide]');
      const track = root.querySelector('[data-mp-track]');
      const dots = root.querySelectorAll('[data-mp-dot]');

      const goTo = (idx) => {
        slides.forEach((s, i) => {
          if (i === idx) s.scrollIntoView({ inline: 'start', behavior: 'smooth', block: 'nearest' });
        });
        thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      };

      thumbs.forEach((t, i) => {
        t.addEventListener('click', () => goTo(i));
      });

      // Sync dots/thumbs to scroll position
      if (track) {
        track.addEventListener('scroll', () => {
          const idx = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
          dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
        }, { passive: true });
      }

      // Share
      const shareBtn = root.querySelector('[data-mp-share]');
      shareBtn?.addEventListener('click', async () => {
        const url = window.location.href;
        const title = document.title;
        try {
          if (navigator.share) await navigator.share({ url, title });
          else { await navigator.clipboard.writeText(url); shareBtn.setAttribute('aria-label', 'Link copied'); }
        } catch (_) {}
      });

      // Favorites — same pattern as product-card
      const FAV_KEY = 'clab:favorites';
      const getFavs = () => { try { return JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); } catch { return []; } };
      const setFavs = (arr) => localStorage.setItem(FAV_KEY, JSON.stringify(arr));
      const favBtn = root.querySelector('[data-favorite]');
      if (favBtn) {
        const id = favBtn.dataset.favorite;
        const favs = getFavs();
        if (favs.includes(id)) favBtn.setAttribute('aria-pressed', 'true');
        favBtn.addEventListener('click', () => {
          const list = getFavs();
          const idx = list.indexOf(id);
          const countEl = favBtn.querySelector('[data-favorite-count]');
          let count = parseInt(countEl?.textContent || '0', 10) || 0;
          if (idx >= 0) { list.splice(idx, 1); favBtn.setAttribute('aria-pressed', 'false'); count = Math.max(0, count - 1); }
          else { list.push(id); favBtn.setAttribute('aria-pressed', 'true'); count += 1; }
          setFavs(list);
          if (countEl) countEl.textContent = String(count);
        });
      }

      // Variant selector — option buttons update hidden form id + price + availability
      const variantsJsonEl = root.querySelector('[data-mp-variants-json]');
      const variantInput = root.querySelector('[data-mp-variant-input]');
      const priceNowEl = root.querySelector('.main-product__price-now');
      const priceWasEl = root.querySelector('.main-product__price-was');
      const addBtn = root.querySelector('.main-product__add-btn');
      // Ex-VAT aware price formatter. When settings.show_ex_vat_prices is on and
      // the current market != home country, the ex-vat-init snippet flags
      // <html data-ex-vat="true"> + window.__vwsExVat with the applied rate;
      // divide by (100 + rate) to match the server-rendered display.
      const formatPrice = (cents) => {
        try {
          if (window.__vwsExVat && window.__vwsExVat.active) {
            cents = window.__vwsExVat.applyToCents(cents);
          }
          return (cents / 100).toFixed(2).replace('.', ',') + ' EUR';
        } catch { return ''; }
      };
      let variants = [];
      if (variantsJsonEl) { try { variants = JSON.parse(variantsJsonEl.textContent.trim()); } catch (e) { console.error('[main-product] variants json parse', e); } }

      const collectSelections = () => {
        const groups = root.querySelectorAll('[data-mp-option-group]');
        const sel = [];
        groups.forEach(g => {
          const pos = parseInt(g.dataset.mpOptionGroup, 10);
          const active = g.querySelector('.main-product__variant-btn.is-selected');
          if (active) sel[pos - 1] = active.dataset.value;
        });
        return sel;
      };
      const findVariant = (sel) => variants.find(v => sel.every((val, i) => v.options[i] === val));
      // With-VAT formatter for the ex-VAT note's inline equivalent amount.
      // formatPrice() above divides when active; this variant always leaves
      // the raw cents intact so the "X con IVA español" reference stays right.
      const formatWithVat = (cents) => {
        try { return (cents / 100).toFixed(2).replace('.', ',') + ' EUR'; } catch { return ''; }
      };
      const equivNoteEl = root.querySelector('[data-ex-vat-equiv-price]');
      const updateUI = () => {
        const sel = collectSelections();
        const v = findVariant(sel);
        if (!v) return;
        variantInput.value = v.id;
        if (priceNowEl) priceNowEl.textContent = formatPrice(v.price);
        if (priceWasEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            priceWasEl.textContent = formatPrice(v.compare_at_price);
            priceWasEl.style.display = '';
          } else priceWasEl.style.display = 'none';
        }
        // Keep the ex-VAT note in sync with the selected variant so the "X con
        // IVA español" reference reflects THIS variant (not product.price).
        if (equivNoteEl) equivNoteEl.textContent = formatWithVat(v.price);
        if (addBtn) {
          if (!v.available) {
            addBtn.classList.add('is-disabled');
            addBtn.disabled = true;
            const span = addBtn.querySelector('.main-product__add-btn-label') || addBtn.querySelector('span');
            if (span) span.textContent = 'Sold out';
          } else {
            addBtn.classList.remove('is-disabled');
            addBtn.disabled = false;
          }
        }
        // Update displayed value labels
        root.querySelectorAll('[data-mp-option-selected]').forEach(label => {
          const pos = parseInt(label.dataset.mpOptionSelected, 10);
          if (sel[pos - 1]) label.textContent = sel[pos - 1];
        });
        // Update unavailable state on buttons (mark options that have no available variants given other selections)
        root.querySelectorAll('[data-mp-option-group]').forEach(group => {
          const pos = parseInt(group.dataset.mpOptionGroup, 10);
          group.querySelectorAll('[data-mp-option-btn]').forEach(btn => {
            const trial = sel.slice(); trial[pos - 1] = btn.dataset.value;
            const match = findVariant(trial);
            btn.classList.toggle('is-unavailable', !(match && match.available));
          });
        });
      };

      root.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-mp-option-btn]');
        if (!btn) return;
        if (btn.classList.contains('is-unavailable')) return;
        const group = btn.closest('[data-mp-option-group]');
        if (!group) return;
        group.querySelectorAll('.main-product__variant-btn').forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        updateUI();
      });
      // Run once to flag unavailable on initial selection. Skip when no
      // option group is rendered (e.g. the only option, KG, is hidden here
      // and handled by the Pack y ahorra tiers) — otherwise findVariant([])
      // would match the first variant and clobber the tier's selection.
      if (variants.length && root.querySelector('[data-mp-option-group]')) updateUI();

      // Mobile sticky add-to-cart bar — visible only when the inline Add-to-cart button leaves the viewport.
      const inlineAddBtn = root.querySelector('.main-product__add-btn');
      const stickyBar = root.querySelector('[data-mp-sticky-bar]');
      if (inlineAddBtn && stickyBar && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(([entry]) => {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        }, { rootMargin: '0px', threshold: 0 });
        io.observe(inlineAddBtn);
      }
      // Sticky bar button → trigger inline submit
      const stickyAdd = root.querySelector('[data-mp-sticky-add]');
      stickyAdd?.addEventListener('click', () => {
        const form = root.querySelector('.main-product__form');
        form?.requestSubmit ? form.requestSubmit() : form?.submit();
      });

      // "More details" modal — click [data-mp-more-details] opens overlay
      const detailsModal = root.querySelector('[data-mp-details-modal]');
      if (detailsModal) {
        const openDetails = () => { detailsModal.classList.add('is-open'); detailsModal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
        const closeDetails = () => { detailsModal.classList.remove('is-open'); detailsModal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
        root.addEventListener('click', (e) => {
          if (e.target.closest('[data-mp-more-details]')) { e.preventDefault(); openDetails(); }
        });
        detailsModal.addEventListener('click', (e) => {
          if (e.target.closest('[data-mp-details-close]') || e.target === detailsModal.querySelector('[data-mp-details-overlay]') || e.target.classList.contains('main-product__details-overlay')) closeDetails();
        });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && detailsModal.classList.contains('is-open')) closeDetails(); });
      }

      // Desktop lightbox — click main media opens fullscreen overlay
      const lightbox = root.querySelector('[data-mp-lightbox]');
      const lightboxTrack = root.querySelector('[data-mp-lightbox-track]');
      const lightboxClose = root.querySelector('[data-mp-lightbox-close]');
      const mainMedia = root.querySelector('[data-mp-main]');
      if (lightbox && mainMedia) {
        const isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;
        if (isDesktop()) mainMedia.setAttribute('data-lightbox', 'true');
        const openLightbox = () => {
          if (!isDesktop()) return;
          // Sync to current main image index
          const currentIdx = Math.round((root.querySelector('[data-mp-track]')?.scrollLeft || 0) / (root.querySelector('[data-mp-track]')?.clientWidth || 1));
          lightbox.classList.add('is-open');
          lightbox.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
          if (lightboxTrack && lightboxTrack.children[currentIdx]) {
            lightboxTrack.scrollLeft = currentIdx * lightboxTrack.clientWidth;
          }
        };
        const closeLightbox = () => {
          lightbox.classList.remove('is-open');
          lightbox.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        };
        mainMedia.addEventListener('click', openLightbox);
        lightboxClose?.addEventListener('click', closeLightbox);
        lightbox.addEventListener('click', (e) => { if (e.target === lightbox) closeLightbox(); });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeLightbox(); });
        window.addEventListener('resize', () => { mainMedia.setAttribute('data-lightbox', isDesktop() ? 'true' : 'false'); });
      }
    });

    // Reseller pack tiers: click a radio → mark .is-selected + sync the form's
    // hidden qty input + update headline PDP price for the selected tier total.
    function applyResellerTier(radio) {
      if (!radio) return;
      const root = radio.closest('.main-product') || document;
      const tiersList = radio.closest('[data-mp-reseller]');
      tiersList?.querySelectorAll('.bundle__tier').forEach((li) => li.classList.remove('is-selected'));
      radio.closest('.bundle__tier')?.classList.add('is-selected');
      // The Liquid `checked` attribute paints the input but a click on the label
      // doesn't fire `change` if it was already pre-selected — force the prop.
      radio.checked = true;
      const form = root.querySelector('.main-product__form');
      if (form) {
        let qtyInput = form.querySelector('[name="quantity"]');
        if (!qtyInput) {
          qtyInput = document.createElement('input');
          qtyInput.type = 'hidden';
          qtyInput.name = 'quantity';
          form.appendChild(qtyInput);
        }
        qtyInput.value = radio.dataset.resellerQty;
        form.dataset.resellerCode = radio.dataset.resellerCode || '';
      }
      // Update headline price row to the tier total (discounted + compare-at)
      const now = radio.dataset.resellerNow;
      const was = radio.dataset.resellerWas;
      const priceNow = root.querySelector('[data-mp-price-now]');
      const priceWas = root.querySelector('[data-mp-price-was]');
      // money_with_currency may include the store's custom money format
      // (e.g. <span class=dualPrice>...</span>) — use innerHTML so the
      // markup renders instead of being shown as escaped text.
      if (priceNow && now) priceNow.innerHTML = now;
      if (priceWas && was) { priceWas.innerHTML = was; priceWas.style.display = ''; }
      // Sticky mobile bar mirror
      const stickyPrice = root.querySelector('.main-product__sticky-price');
      if (stickyPrice && now) stickyPrice.innerHTML = now;
      // Ex-VAT note equiv-price mirror. The Liquid emits the tier's
      // pre-divide (with-VAT) amount as data-reseller-was-with-vat so
      // the note stays coherent when the user picks another tier.
      const equivEl = root.querySelector('[data-ex-vat-equiv-price]');
      const equivWithVat = radio.dataset.resellerWasWithVat;
      if (equivEl && equivWithVat) equivEl.textContent = equivWithVat;
      // Update product title with tier-multiplied prefix (10x → 20x → 30x)
      const titleEl = root.querySelector('[data-mp-title]');
      const tierTitle = radio.dataset.resellerTitle;
      if (titleEl && tierTitle) titleEl.textContent = tierTitle;
    }
    document.addEventListener('change', (e) => {
      const radio = e.target.closest('[data-reseller-qty]');
      if (radio) applyResellerTier(radio);
    });

    // On load: apply the default checked tier (stamps form qty/code + price)
    document.querySelectorAll('[data-mp-reseller]').forEach((tiersList) => {
      const checked = tiersList.querySelector('[data-reseller-qty]:checked')
                   || tiersList.querySelector('[data-reseller-qty]'); // fallback: first
      applyResellerTier(checked);
    });

    // Add-to-cart submit → AJAX + (optional discount apply) + cart drawer open
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('.main-product__form');
      if (!form) return;
      e.preventDefault();
      const submitBtn = form.querySelector('button[type="submit"]');
      submitBtn?.classList.add('is-disabled');
      try {
        // Reseller pack tiers: read the currently-selected radio's code + qty
        // direct from the DOM (more robust than relying on the change handler
        // having stamped form.dataset). Also force-set the qty on the form.
        const root = form.closest('.main-product') || document;
        const resellerRadio = root.querySelector('[data-reseller-qty]:checked');
        if (resellerRadio) {
          let qtyInput = form.querySelector('[name="quantity"]');
          if (!qtyInput) {
            qtyInput = document.createElement('input');
            qtyInput.type = 'hidden'; qtyInput.name = 'quantity';
            form.appendChild(qtyInput);
          }
          qtyInput.value = resellerRadio.dataset.resellerQty;
          form.dataset.resellerCode = resellerRadio.dataset.resellerCode || '';
        }

        const fd = new FormData(form);
        const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } });
        if (!res.ok) throw new Error('add failed');
        // Discount tier is handled by 3 Shopify automatic discounts (qty ≥ 1/2/3
        // of reseller-packs items → 5/10/15% off). Shopify auto-applies the best
        // one — no manual /discount/CODE call needed here.
        document.dispatchEvent(new CustomEvent('cart:item-added'));
      } catch (err) {
        console.error('[main-product] add to cart failed', err);
      } finally {
        submitBtn?.classList.remove('is-disabled');
      }
    });
  })();

  (function () {
    /* Variant-driven volume tiers. Each tier maps to a real product
       variant; selecting one sets the hidden variant id so the right
       SKU is added to cart. When the standalone option-button picker
       (block 'variants') is ALSO present for the same option, we click
       its matching button so the existing variant pipeline owns
       price/availability and both controls stay in sync. When it is
       absent, the tier drives the headline price directly. */
    document.querySelectorAll('[data-mp-volume]').forEach((group) => {
      const root = group.closest('.main-product') || document;
      const variantInput = root.querySelector('[data-mp-variant-input]');
      const priceNow = root.querySelector('[data-mp-price-now]');
      const priceWas = root.querySelector('[data-mp-price-was]');
      const stickyPrice = root.querySelector('.main-product__sticky-price');
      const btnGroup = root.querySelector('[data-mp-option-group="' + group.dataset.position + '"]');
      const hasButtons = !!btnGroup;

      const applyPrice = (radio) => {
        // data-price / data-compare hold the money_with_currency markup
        // (the shop's currency app wraps amounts in <span>), so use
        // innerHTML to keep the headline consistent with first paint.
        const now = radio.dataset.price || '';
        const was = radio.dataset.compare || '';
        if (priceNow && now) priceNow.innerHTML = now;
        if (stickyPrice && now) stickyPrice.innerHTML = now;
        if (priceWas) {
          if (was) { priceWas.innerHTML = was; priceWas.style.display = ''; }
          else { priceWas.innerHTML = ''; priceWas.style.display = 'none'; }
        }
      };

      const selectTier = (radio, drive) => {
        if (!radio) return;
        group.querySelectorAll('.bundle__tier').forEach((t) => t.classList.remove('is-selected'));
        radio.closest('.bundle__tier')?.classList.add('is-selected');
        if (drive && hasButtons) {
          // Hand off to the option-button pipeline (owns id + price + availability).
          const btn = [...btnGroup.querySelectorAll('[data-mp-option-btn]')]
            .find((b) => b.dataset.value === radio.dataset.value);
          if (btn && !btn.classList.contains('is-selected')) btn.click();
        } else {
          // No button picker — drive the variant directly.
          if (variantInput && radio.dataset.variantId) variantInput.value = radio.dataset.variantId;
          applyPrice(radio);
        }
      };

      group.addEventListener('change', (e) => {
        const radio = e.target.closest('[data-vol-radio]');
        if (radio) selectTier(radio, true);
      });

      // Reverse sync: option-button click → reflect into the tiers.
      if (hasButtons) {
        root.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-mp-option-btn]');
          if (!btn) return;
          const pos = btn.closest('[data-mp-option-group]')?.dataset.mpOptionGroup;
          if (pos !== group.dataset.position) return;
          const radio = [...group.querySelectorAll('[data-vol-radio]')]
            .find((r) => r.dataset.value === btn.dataset.value);
          if (radio && !radio.checked) { radio.checked = true; selectTier(radio, false); }
        });
      }

      // Initial sync so the page loads coherent on first paint.
      const initial = group.querySelector('[data-vol-radio]:checked') || group.querySelector('[data-vol-radio]');
      if (initial) { initial.checked = true; selectTier(initial, true); }
    });
  })();

  /* Delivery urgency countdown — random 2h-6h target written to
     localStorage so the timer survives page navigations and only
     regenerates when it actually hits zero. Updates every minute. */
  (function () {
    var KEY = 'mp-delivery-countdown';
    var MIN_SEC = 2 * 60 * 60;
    var MAX_SEC = 6 * 60 * 60;

    function randomTarget() {
      var span = MAX_SEC - MIN_SEC;
      var secs = MIN_SEC + Math.floor(Math.random() * span);
      return Date.now() + secs * 1000;
    }

    function getTarget() {
      var raw = null;
      try { raw = localStorage.getItem(KEY); } catch (_) {}
      var t = raw ? parseInt(raw, 10) : 0;
      if (!t || isNaN(t) || t <= Date.now()) {
        t = randomTarget();
        try { localStorage.setItem(KEY, String(t)); } catch (_) {}
      }
      return t;
    }

    function format(target, node) {
      var ms = target - Date.now();
      if (ms <= 0) return '';
      var totalMins = Math.floor(ms / 60000);
      var hours = Math.floor(totalMins / 60);
      var mins = totalMins % 60;
      var hOne = (node && node.dataset.tHourOne) || 'hora';
      var hOther = (node && node.dataset.tHourOther) || 'horas';
      var mOne = (node && node.dataset.tMinOne) || 'min';
      var mOther = (node && node.dataset.tMinOther) || 'mins';
      var parts = [];
      if (hours > 0) parts.push(hours + ' ' + (hours === 1 ? hOne : hOther));
      parts.push(mins + ' ' + (mins === 1 ? mOne : mOther));
      return parts.join(' ');
    }

    function update() {
      var nodes = document.querySelectorAll('[data-mp-countdown]');
      if (!nodes.length) return;
      var target = getTarget();
      var text = format(target, nodes[0]);
      nodes.forEach(function (n) { n.textContent = text; });
    }

    update();
    document.addEventListener('DOMContentLoaded', update);
    setInterval(update, 60000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-wishlist-root]');
    if (!root) return;
    var grid    = root.querySelector('[data-wishlist-grid]');
    var empty   = root.querySelector('[data-wishlist-empty]');
    var count   = root.querySelector('[data-wishlist-count-text]');
    var countN  = root.querySelector('[data-wishlist-count-num]');

    function readFavs() {
      if (window.ClabWishlist && typeof window.ClabWishlist.getFavs === 'function') {
        return window.ClabWishlist.getFavs() || [];
      }
      try { return JSON.parse(localStorage.getItem('clab:favorites') || '[]'); }
      catch (_) { return []; }
    }

    function formatPrice(cents) {
      try {
        var v = (cents / 100).toFixed(2).replace('.', ',');
        return v + ' €';
      } catch (_) { return ''; }
    }

    function escapeAttr(s) {
      return String(s || '').replace(/"/g, '&quot;');
    }

    function showEmpty() {
      if (empty) empty.removeAttribute('hidden');
      if (grid) grid.setAttribute('hidden', '');
      if (count) count.setAttribute('hidden', '');
    }

    function showGrid(n) {
      if (empty) empty.setAttribute('hidden', '');
      if (grid) grid.removeAttribute('hidden');
      if (count) {
        count.removeAttribute('hidden');
        if (countN) countN.textContent = n;
      }
    }

    async function render() {
      var favs = readFavs();
      if (!favs.length) { showEmpty(); return; }

      var products = await Promise.all(favs.map(async function (handle) {
        try {
          var r = await fetch('/products/' + encodeURIComponent(handle) + '.js', {
            headers: { 'Accept': 'application/json' }
          });
          if (!r.ok) return null;
          var p = await r.json();
          p._handle = handle;
          return p;
        } catch (_) { return null; }
      }));
      var valid = products.filter(Boolean);
      if (!valid.length) { showEmpty(); return; }

      var heartSvg =
        '<svg class="product-card__wishlist-icon" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 1 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>' +
        '</svg>';

      grid.innerHTML = valid.map(function (p) {
        var img = (p.featured_image || (p.images && p.images[0]) || '').replace(/^\/\//, 'https://');
        var title = escapeAttr(p.title);
        return '' +
          '<li class="main-wishlist__cell">' +
            '<article class="product-card" style="--pc-aspect: 3/4;">' +
              '<div class="product-card__media">' +
                '<a href="' + p.url + '" class="product-card__image-link" aria-label="' + title + '">' +
                  '<img class="product-card__image" src="' + img + '" alt="' + title + '" loading="lazy">' +
                '</a>' +
                '<button type="button" class="product-card__wishlist is-favorited" data-wishlist-product="' + escapeAttr(p._handle) + '" aria-pressed="true">' +
                  heartSvg +
                  '<span class="product-card__wishlist-count" data-wishlist-count>0</span>' +
                '</button>' +
              '</div>' +
              '<div class="product-card__info">' +
                '<a href="' + p.url + '" class="product-card__title">' + p.title + '</a>' +
                (p.type ? '<span class="product-card__category">' + p.type + '</span>' : '') +
                '<span class="product-card__price">' +
                  '<span class="product-card__price-now">' + formatPrice(p.price) + '</span>' +
                '</span>' +
              '</div>' +
            '</article>' +
          '</li>';
      }).join('');

      showGrid(valid.length);
      if (window.ClabWishlist && typeof window.ClabWishlist.sync === 'function') {
        window.ClabWishlist.sync();
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', render);
    } else {
      render();
    }
    // Re-render if storage changes from another tab.
    window.addEventListener('storage', function (e) {
      if (e.key === 'clab:favorites') render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["margin-calc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mcalc]').forEach((root) => {
      const $u = root.querySelector('[data-mcalc-units]');
      const $b = root.querySelector('[data-mcalc-buy]');
      const $s = root.querySelector('[data-mcalc-sell]');
      const $cost = root.querySelector('[data-mcalc-cost]');
      const $rev  = root.querySelector('[data-mcalc-revenue]');
      const $prof = root.querySelector('[data-mcalc-profit]');
      const $x    = root.querySelector('[data-mcalc-x]');

      const eur = (n) => new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(Math.round(n));
      const num = (el) => {
        const v = parseFloat(String(el.value).replace(',', '.'));
        return isFinite(v) && v >= 0 ? v : 0;
      };

      const calc = () => {
        const u = num($u), b = num($b), s = num($s);
        const cost = u * b;
        const rev = u * s;
        const profit = rev - cost;
        const mult = cost > 0 ? rev / cost : 0;
        if ($cost) $cost.textContent = eur(cost);
        if ($rev)  $rev.textContent  = eur(rev);
        if ($prof) $prof.textContent = eur(profit);
        if ($x) $x.textContent = mult ? '×' + mult.toFixed(1).replace('.', ',') + ' multiplicas tu inversión' : '';
      };

      [$u, $b, $s].forEach((el) => el && el.addEventListener('input', calc));
      calc();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function wireScrollbar(root) {
      const track = root.querySelector('[data-pr-track]');
      const bar   = root.querySelector('[data-pr-scrollbar]');
      const thumb = root.querySelector('[data-pr-thumb]');
      if (!track || !bar || !thumb) return;
      const updateBar = () => {
        const visible = track.clientWidth;
        const total   = track.scrollWidth;
        if (total <= visible + 1) { bar.setAttribute('hidden', ''); return; }
        bar.removeAttribute('hidden');
        const trackW = bar.clientWidth;
        const ratio  = visible / total;
        const thumbW = Math.max(24, trackW * ratio);
        const maxScr = total - visible;
        const tx     = maxScr > 0 ? (track.scrollLeft / maxScr) * (trackW - thumbW) : 0;
        thumb.style.setProperty('--pr-thumb-w', thumbW + 'px');
        thumb.style.setProperty('--pr-thumb-x', tx + 'px');
      };
      track.addEventListener('scroll', updateBar, { passive: true });
      window.addEventListener('resize', updateBar);
      if ('ResizeObserver' in window) new ResizeObserver(updateBar).observe(track);
      requestAnimationFrame(updateBar);
    }

    document.querySelectorAll('[data-product-recs]').forEach(async (root) => {
      const productId = root.dataset.productId;
      const sectionId = root.dataset.sectionId;
      const limit = root.dataset.limit;
      const intent = root.dataset.intent;
      // If recommendations didn't render server-side (rare), fetch via the
      // recommendations endpoint and inject the section HTML.
      const track = root.querySelector('[data-pr-track]');
      if (!track) return;
      if (track.children.length > 0) {
        wireScrollbar(root);
        return;
      }
      try {
        const url = `/recommendations/products?section_id=${sectionId}&product_id=${productId}&limit=${limit}&intent=${intent}`;
        const res = await fetch(url);
        if (!res.ok) throw new Error('reco fetch failed');
        const html = await res.text();
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const newTrack = tmp.querySelector('[data-pr-track]');
        if (newTrack && newTrack.children.length > 0) {
          track.replaceWith(newTrack);
          wireScrollbar(root);
        } else {
          root.dataset.empty = 'true';
        }
      } catch (err) {
        console.error('[product-recs] fetch failed', err);
        root.dataset.empty = 'true';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.product-row').forEach((root) => {
      const track = root.querySelector('[data-pr-track]');
      const prev = root.querySelector('[data-pr-prev]');
      const next = root.querySelector('[data-pr-next]');
      if (!track) return;
      const step = () => track.clientWidth * 0.85;
      const update = () => {
        const max = track.scrollWidth - track.clientWidth - 1;
        prev?.classList.toggle('is-disabled', track.scrollLeft <= 0);
        next?.classList.toggle('is-disabled', track.scrollLeft >= max);
      };
      prev?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: step(),  behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.ps').forEach((root) => {
      const track = root.querySelector('[data-ps-track]');
      const prev  = root.querySelector('[data-ps-prev]');
      const next  = root.querySelector('[data-ps-next]');
      const bar   = root.querySelector('[data-ps-bar]');
      const thumb = root.querySelector('[data-ps-bar-thumb]');
      if (!track) return;

      const step = () => Math.max(track.clientWidth * 0.8, 200);

      const sync = () => {
        const max = track.scrollWidth - track.clientWidth - 1;
        prev && prev.classList.toggle('is-disabled', track.scrollLeft <= 0);
        next && next.classList.toggle('is-disabled', track.scrollLeft >= max);

        // Custom scrollbar — thumb width = visible / total, position = scroll progress.
        if (thumb && bar) {
          const barW = bar.clientWidth;
          const ratio = track.clientWidth / track.scrollWidth;
          const tw = Math.max(barW * ratio, 28);
          thumb.style.width = tw + 'px';
          const progress = max > 0 ? track.scrollLeft / max : 0;
          const offset = (barW - tw) * progress;
          thumb.style.transform = `translateX(${offset}px)`;
        }
      };

      prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => track.scrollBy({ left:  step(), behavior: 'smooth' }));
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);

      // Click-to-jump on the bar track
      bar && bar.addEventListener('click', (e) => {
        if (e.target === thumb) return;
        const rect = bar.getBoundingClientRect();
        const ratio = (e.clientX - rect.left) / rect.width;
        const max = track.scrollWidth - track.clientWidth;
        track.scrollTo({ left: max * ratio, behavior: 'smooth' });
      });

      // Drag the thumb to scrub
      let dragging = false, dragStartX = 0, dragStartScroll = 0;
      thumb && thumb.addEventListener('pointerdown', (e) => {
        dragging = true;
        dragStartX = e.clientX;
        dragStartScroll = track.scrollLeft;
        thumb.setPointerCapture(e.pointerId);
        e.preventDefault();
      });
      thumb && thumb.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        const barW = bar.clientWidth;
        const tw = thumb.clientWidth;
        const max = track.scrollWidth - track.clientWidth;
        const dx = e.clientX - dragStartX;
        const scrollRatio = max / Math.max(barW - tw, 1);
        track.scrollLeft = dragStartScroll + dx * scrollRatio;
      });
      thumb && thumb.addEventListener('pointerup', () => { dragging = false; });

      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banners"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.pb').forEach((root) => {
      const track = root.querySelector('[data-pb-track]');
      if (!track) return;

      // Pointer-driven drag-to-scroll. Native touch swipe still works on top
      // of this (touch events don't fire pointerdown unless desktop emulates).
      let pointerDown = false;
      let dragging = false;
      let startX = 0;
      let startScroll = 0;
      let moved = 0;
      let lastX = 0, lastT = 0, velocity = 0, raf = 0, activeId = null;
      const DRAG_THRESHOLD = 6;

      const onDown = (e) => {
        // Only react to mouse/pen; let native touch handle itself.
        if (e.pointerType === 'touch') return;
        cancelAnimationFrame(raf);
        pointerDown = true;
        dragging = false;
        moved = 0;
        velocity = 0;
        startX = e.clientX;
        lastX = e.clientX;
        lastT = performance.now();
        startScroll = track.scrollLeft;
        activeId = e.pointerId;
        // NB: no is-dragging / pointer capture here — that would kill clicks
        // on the banner links. We only enter drag mode past DRAG_THRESHOLD.
      };
      const onMove = (e) => {
        if (!pointerDown) return;
        const dx = e.clientX - startX;
        moved = Math.abs(dx);
        if (!dragging) {
          if (moved < DRAG_THRESHOLD) return; // still a click candidate
          dragging = true;
          track.classList.add('is-dragging');
          try { track.setPointerCapture && track.setPointerCapture(activeId); } catch (_) {}
        }
        track.scrollLeft = startScroll - dx;
        const now = performance.now();
        const dt = now - lastT;
        if (dt > 0) velocity = (e.clientX - lastX) / dt; // px per ms
        lastX = e.clientX;
        lastT = now;
      };
      const onUp = (e) => {
        if (!pointerDown) return;
        pointerDown = false;
        try { track.releasePointerCapture && track.releasePointerCapture(e.pointerId); } catch (_) {}
        if (!dragging) return; // pure click — let the link navigate
        // Inertia: keep gliding, then drop is-dragging (re-enables snap) at rest.
        const glide = () => {
          velocity *= 0.93;
          track.scrollLeft -= velocity * 16;
          if (Math.abs(velocity) > 0.04) {
            raf = requestAnimationFrame(glide);
          } else {
            track.classList.remove('is-dragging');
            dragging = false;
          }
        };
        if (Math.abs(velocity) > 0.06) {
          raf = requestAnimationFrame(glide);
        } else {
          track.classList.remove('is-dragging');
          dragging = false;
        }
      };

      track.addEventListener('pointerdown', onDown);
      track.addEventListener('pointermove', onMove);
      track.addEventListener('pointerup', onUp);
      track.addEventListener('pointercancel', onUp);
      track.addEventListener('pointerleave', onUp);

      // Swallow the click only when the gesture actually became a drag, so a
      // normal click on a banner navigates. Sub-threshold jitter is allowed.
      track.addEventListener('click', (e) => {
        if (moved >= DRAG_THRESHOLD) { e.preventDefault(); e.stopPropagation(); }
      }, true);

      // Desktop arrows: scroll one card per click, hide when nothing
      // overflows, disable at each end.
      const prevBtn = root.querySelector('[data-pb-prev]');
      const nextBtn = root.querySelector('[data-pb-next]');
      const stepSize = () => {
        const slide = track.querySelector('.pb__slide');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
      };
      const updateArrows = () => {
        if (!prevBtn || !nextBtn) return;
        const overflow = (track.scrollWidth - track.clientWidth) > 2;
        prevBtn.hidden = !overflow;
        nextBtn.hidden = !overflow;
        if (!overflow) return;
        prevBtn.disabled = track.scrollLeft <= 1;
        nextBtn.disabled = (track.scrollLeft + track.clientWidth) >= (track.scrollWidth - 1);
      };
      prevBtn && prevBtn.addEventListener('click', () => track.scrollBy({ left: -stepSize(), behavior: 'smooth' }));
      nextBtn && nextBtn.addEventListener('click', () => track.scrollBy({ left: stepSize(), behavior: 'smooth' }));
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const KEY = 'clab:recently-viewed';
    const get = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; } };
    const set = (arr) => localStorage.setItem(KEY, JSON.stringify(arr.slice(0, 16)));

    document.querySelectorAll('[data-recently-viewed]').forEach(async (root) => {
      const currentHandle = root.dataset.currentHandle;
      const limit = parseInt(root.dataset.limit, 10) || 8;
      const track = root.querySelector('[data-rv-track]');

      // Track: if we're on a PDP, push current handle to the front of the list (dedup)
      if (currentHandle) {
        const arr = get().filter(h => h !== currentHandle);
        arr.unshift(currentHandle);
        set(arr);
      }

      const recent = get().filter(h => h !== currentHandle).slice(0, limit);
      if (!recent.length) { root.hidden = true; return; }

      const formatPrice = (cents) => { try { return '€' + (cents / 100).toFixed(2).replace('.', ','); } catch { return ''; } };
      // Best (lowest) real price per unit/kg. Quantity + unit come from the
      // variant value ("10 ud", "5 kg"); falls back to the count in the
      // product title ("10x JERSEYS…"). Returns null when none is parseable.
      const bestUnit = (p) => {
        let best = 0, isKg = false;
        for (const v of (p.variants || [])) {
          for (const opt of (v.options || [])) {
            const qty = parseInt(String(opt), 10);
            if (qty > 0) {
              const u = v.price / qty;
              if (best === 0 || u < best) { best = u; isKg = /kg|kilo/i.test(String(opt)); }
              break;
            }
          }
        }
        if (best === 0) {
          const tq = parseInt(String(p.title), 10);
          if (tq > 0) { best = p.price / tq; isKg = false; }
        }
        return best > 0 ? { price: best, isKg } : null;
      };
      const escapeAttr = (s) => String(s || '').replace(/"/g, '&quot;');
      const cards = await Promise.all(recent.map(async (handle) => {
        try {
          const res = await fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } });
          if (!res.ok) return null;
          return await res.json();
        } catch { return null; }
      }));
      const valid = cards.filter(Boolean);
      if (!valid.length) { root.hidden = true; return; }
      const cartSvg = '<svg class="product-card__add-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M1 2h3l2.2 12.3a2 2 0 0 0 2 1.7h9.3a2 2 0 0 0 2-1.5L21.5 6H6"/></svg>';
      track.innerHTML = valid.map(p => `
        <li class="recently-viewed__slide">
          <article class="product-card">
            <div class="product-card__media">
              <a href="${p.url}" class="product-card__image-link" aria-label="${escapeAttr(p.title)}">
                <img class="product-card__image" src="${(p.featured_image || p.images?.[0] || '').replace(/^\/\//, 'https://')}" alt="${escapeAttr(p.title)}" loading="lazy">
              </a>
            </div>
            <div class="product-card__info">
              <div class="product-card__badges">
                <span class="product-card__badge product-card__badge--primary${p.compare_at_price > p.price ? ' product-card__badge--sale' : ''}">${p.compare_at_price > p.price ? (root.dataset.i18nSale || 'On sale') : (root.dataset.i18nNew || 'New')}</span>
              </div>
              <a href="${p.url}" class="product-card__title">${p.title}</a>
              ${p.type ? `<span class="product-card__category">${p.type}</span>` : ''}
              <span class="product-card__price${p.compare_at_price > p.price ? ' is-on-sale' : ''}">
                <span class="product-card__price-now">${formatPrice(p.price)}</span>
                ${p.compare_at_price > p.price ? `<s class="product-card__price-was">${formatPrice(p.compare_at_price)}</s>` : ''}
                ${(() => { const bu = bestUnit(p); return bu ? `<span class="product-card__price-per-unit">${formatPrice(bu.price)} ${bu.isKg ? (root.dataset.i18nPerKg || '/ kg') : (root.dataset.i18nPerUnit || '/ pc')}</span>` : ''; })()}
              </span>
            </div>
            <div class="product-card__actions">
              <button type="button" class="product-card__add" data-add-to-cart data-variant-id="${p.variants?.[0]?.id || ''}" data-handle="${escapeAttr(p.handle)}" data-multi="${p.variants?.length > 1 ? 'true' : 'false'}" ${p.variants?.length > 1 ? `data-choose-size="${escapeAttr(p.handle)}"` : ''}>
                ${cartSvg}
                <span class="product-card__add-label">${root.dataset.i18nAdd || 'Add'}</span>
              </button>
            </div>
          </article>
        </li>
      `).join('');
      root.hidden = false;

      // Custom mobile scrollbar — width/X driven from visible/total ratio.
      const bar   = root.querySelector('[data-rv-scrollbar]');
      const thumb = root.querySelector('[data-rv-thumb]');
      if (bar && thumb) {
        const updateBar = () => {
          const visible = track.clientWidth;
          const total   = track.scrollWidth;
          if (total <= visible + 1) { bar.setAttribute('hidden', ''); return; }
          bar.removeAttribute('hidden');
          const trackW = bar.clientWidth;
          const ratio  = visible / total;
          const thumbW = Math.max(24, trackW * ratio);
          const maxScr = total - visible;
          const tx     = maxScr > 0 ? (track.scrollLeft / maxScr) * (trackW - thumbW) : 0;
          thumb.style.setProperty('--rv-thumb-w', thumbW + 'px');
          thumb.style.setProperty('--rv-thumb-x', tx + 'px');
        };
        track.addEventListener('scroll', updateBar, { passive: true });
        window.addEventListener('resize', updateBar);
        if ('ResizeObserver' in window) new ResizeObserver(updateBar).observe(track);
        requestAnimationFrame(updateBar);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trustpilot-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.tpr').forEach((root) => {
      const track = root.querySelector('[data-tpr-track]');
      const prev  = root.querySelector('[data-tpr-prev]');
      const next  = root.querySelector('[data-tpr-next]');
      if (!track) return;

      const bar    = root.querySelector('[data-tpr-scrollbar]');
      const thumb  = root.querySelector('[data-tpr-scrollbar-thumb]');

      const step = () => Math.max(track.clientWidth * 0.8, 240);
      const updateBar = () => {
        if (!bar || !thumb) return;
        const visible = track.clientWidth;
        const total   = track.scrollWidth;
        if (total <= visible + 1) {
          bar.setAttribute('hidden', '');
          return;
        }
        bar.removeAttribute('hidden');
        const trackW = bar.clientWidth;
        const ratio  = visible / total;
        const thumbW = Math.max(24, trackW * ratio);
        const maxScr = total - visible;
        const tx     = maxScr > 0 ? (track.scrollLeft / maxScr) * (trackW - thumbW) : 0;
        thumb.style.setProperty('--tpr-thumb-w', thumbW + 'px');
        thumb.style.setProperty('--tpr-thumb-x', tx + 'px');
      };
      const sync = () => {
        const max = track.scrollWidth - track.clientWidth - 1;
        prev && prev.classList.toggle('is-disabled', track.scrollLeft <= 0);
        next && next.classList.toggle('is-disabled', track.scrollLeft >= max);
        updateBar();
      };
      if ('ResizeObserver' in window) {
        new ResizeObserver(updateBar).observe(track);
      }
      prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => track.scrollBy({ left:  step(), behavior: 'smooth' }));
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();

      let isDown = false, startX = 0, startScroll = 0, moved = 0;
      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch') return;
        isDown = true; moved = 0;
        startX = e.clientX; startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
        track.setPointerCapture && track.setPointerCapture(e.pointerId);
      });
      track.addEventListener('pointermove', (e) => {
        if (!isDown) return;
        const dx = e.clientX - startX;
        moved = Math.abs(dx);
        track.scrollLeft = startScroll - dx;
      });
      const up = (e) => {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        try { track.releasePointerCapture && track.releasePointerCapture(e.pointerId); } catch (_) {}
      };
      track.addEventListener('pointerup', up);
      track.addEventListener('pointercancel', up);
      track.addEventListener('pointerleave', up);
      track.addEventListener('click', (e) => {
        if (moved > 5) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warehouse-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-warehouse-slider]').forEach((root) => {
      const slides = [...root.querySelectorAll('[data-whs-slide]')];
      const dots   = [...root.querySelectorAll('[data-whs-dot]')];
      const track  = root.querySelector('[data-whs-dots-track]');
      const autoplay = parseInt(root.dataset.autoplay, 10) || 0;
      const maxVisible = parseInt(root.dataset.visibleDots, 10) || 3;
      let idx = 0;
      let timer = null;

      const dotW = 36; // 32 width + 4 gap
      const setDotsTransform = () => {
        if (!track || slides.length <= maxVisible) return;
        let offset = 0;
        const halfWindow = Math.floor(maxVisible / 2);
        if (idx > halfWindow) {
          offset = Math.min(idx - halfWindow, slides.length - maxVisible) * dotW;
        }
        track.style.transform = `translateX(-${offset}px)`;
      };

      const go = (next) => {
        idx = (next + slides.length) % slides.length;
        slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
        dots.forEach((d, i)   => d.classList.toggle('is-active',   i === idx));
        setDotsTransform();
      };

      dots.forEach((d, i) => d.addEventListener('click', () => { go(i); restart(); }));

      const tick = () => go(idx + 1);
      const start = () => {
        if (!autoplay || slides.length < 2) return;
        timer = setInterval(tick, autoplay * 1000);
      };
      const restart = () => {
        if (timer) clearInterval(timer);
        start();
      };

      setDotsTransform();
      start();

      const content = root.querySelector('.whs__content');
      if (content) {
        const updateParallax = () => {
          const rect = root.getBoundingClientRect();
          const sliderH = root.offsetHeight;
          const contentH = content.offsetHeight;
          const vh = window.innerHeight || document.documentElement.clientHeight;
          const topPad = parseFloat(getComputedStyle(content).top) || 0;
          const range = Math.max(0, sliderH - contentH - topPad * 2);
          let progress = (vh - rect.top) / vh;
          if (progress < 0) progress = 0;
          if (progress > 1) progress = 1;
          content.style.transform = 'translateY(' + (progress * range) + 'px)';
        };
        updateParallax();
        window.addEventListener('scroll', updateParallax, { passive: true });
        window.addEventListener('resize', updateParallax);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
